import { render } from "./VueIndex.vue?vue&type=template&id=899abbee"
import script from "./VueIndex.vue?vue&type=script&lang=js"
export * from "./VueIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__